import React from "react";
import "../css/privacy.scss";

export const POLICY_UPDATED = "October 16, 2026";
export const POLICY_EMAIL = "steps@tugglefield.xyz";

export function PolicyEmail() {
  return <a href={`mailto:${POLICY_EMAIL}`}>{POLICY_EMAIL}</a>;
}

function PolicyPage({ title, intro, sections, children }) {
  return (
    <main className="layout--template" id="main_content">
      <div className="shopify-policy__container">
        <div className="shopify-policy__title">
          <h1>{title}</h1>
        </div>
        <div className="shopify-policy__body">
          <div className="rte">
            <p className="policy-updated">
              <strong>Last updated: {POLICY_UPDATED}</strong>
            </p>
            {intro && <div className="policy-intro">{intro}</div>}
            {sections?.map((section, index) => (
              <section className="policy-section" key={section.title}>
                <h2>
                  {index + 1}. {section.title}
                </h2>
                {section.content}
              </section>
            ))}
            {children}
          </div>
        </div>
      </div>
    </main>
  );
}

export default PolicyPage;
